import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useConfig } from "../../contexts/config-context.js";
import { NUMBER_OF_COLUMNS } from "./options-layout-constants.js";
import styles from "./options-layout.module.scss";
const OptionsLayout = ({
  numberOfColumns,
  children,
  ...rest
}) => {
  const { isMobile } = useConfig();
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(styles.container, {
        [styles.oneColumn]: numberOfColumns === NUMBER_OF_COLUMNS.ONE || isMobile,
        [styles.twoColumns]: numberOfColumns === NUMBER_OF_COLUMNS.TWO && !isMobile,
        [styles.threeColumns]: numberOfColumns === NUMBER_OF_COLUMNS.THREE && !isMobile,
        [styles.freeFlow]: numberOfColumns === NUMBER_OF_COLUMNS.FREE_FLOW
      }),
      ...rest,
      children
    }
  );
};
export {
  OptionsLayout
};
//# sourceMappingURL=options-layout.js.map
